import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Label } from 'semantic-ui-react';

import { SemanticUiColorOptions } from 'Common/Constants/SemanticUiColors';
import ScrollContainer from 'PointOfSale/modules/common/container/ScrollContainer';
import TabMenus from 'PointOfSale/modules/common/component/TabMenus';
import EditSelectedFoodItemsComponent from 'PointOfSale/modules/individualServing/container/EditSelectedFoodItems';
import { LongPressButton } from 'Common/Components/LongPressButton/LongPressButton';
import { ITEMS_PER_ROW } from 'PointOfSale/modules/common/constants';
import { ItemList } from 'PointOfSale/modules/common/component/ItemList';

import { getColor } from '../../../helpers/servedItemButtonColor';

const getButtonDimensions = () => {
  return {
    maxWidth: `${100 / ITEMS_PER_ROW}%`,
  };
};

class ServingFoodItems extends React.Component {
  get selectedFoodItems() {
    const {
      currentSelectedFoodItems,
      searchText,
      servedItemsOrder,
    } = this.props;
    const trimmedSearchText = _.trim(searchText).toLowerCase();

    const selectedFoodItems = _(currentSelectedFoodItems)
      .filter('selected')
      .filter(item => {
        if (trimmedSearchText) {
          return _.lowerCase(item.ShortDescription).includes(trimmedSearchText);
        }
        return true;
      })
      .map(i => ({
        ...i,
        OrderNum: servedItemsOrder[i.ItemId[0]].indexOf(i.ItemId),
      }))
      .sortBy('OrderNum')
      .value();

    return selectedFoodItems;
  }

  renderNoItem = () => {
    return (
      <div className="no-food-error">
        <span> No Item(s) Found </span>
      </div>
    );
  };

  renderItem = (item, index) => {
    const {
      additionalItems,
      onItemClick,
      onItemLongPress,
      nutritionCodes,
      itemCategories,
    } = this.props;

    const selectedItem = additionalItems.find(a => a.ItemId === item.ItemId);
    const color = getColor(item, nutritionCodes, itemCategories);
    const isSemanticColor =
      SemanticUiColorOptions.findIndex(c => c.value === color) > -1;

    return (
      <div
        key={item.ItemId}
        className="serve-item-container flex flex-1"
        style={getButtonDimensions()}
      >
        <LongPressButton
          compact
          size="big"
          fluid
          {...(isSemanticColor
            ? { color }
            : { style: { backgroundColor: color } })}
          className="serve-item-button"
          onClick={() => {
            onItemClick(item);
          }}
          active={!!selectedItem}
          onLongPress={() => {
            onItemLongPress(item);
          }}
        >
          {!!selectedItem && (
            <Label color="teal" floating className="serve-item-floating-label">
              {selectedItem.Qty}
            </Label>
          )}
          {/* Adding a wrapper around the text here so overflowing text can be hidden, but the quantity label which we don't want to be hidden can still show.*/}
          <div className="serve-item-button-text">{item.ShortDescription}</div>
        </LongPressButton>
      </div>
    );
  };

  renderRow = (row, rowIndex) => {
    return (
      <div key={`row-${rowIndex}`} className="flex flex-1">
        <ItemList items={row} renderItem={this.renderItem} />
      </div>
    );
  };

  render() {
    const {
      tabMenus,
      searchText,
      searchHandler,
      tabClickHandler,
      isModalOpen,
      onEditClick,
      onModalToggle,
    } = this.props;

    const tabIcons = [
      {
        icon: 'pencil',
        size: 'large',
        onClick: onEditClick,
      },
    ];

    const items = _.chunk(this.selectedFoodItems, ITEMS_PER_ROW);

    return (
      <React.Fragment>
        <TabMenus
          pointing
          color="orange"
          tabMenus={tabMenus}
          tabIcons={tabIcons}
          searchBox
          searchText={searchText}
          searchHandler={searchHandler}
          tabClickHandler={tabClickHandler}
        />

        <ScrollContainer className={'flex-1'} enableScrollButtons>
          <ItemList items={items} renderItem={this.renderRow} />
          {this.selectedFoodItems.length < 1 && this.renderNoItem()}
        </ScrollContainer>

        <EditSelectedFoodItemsComponent
          padded="vertically"
          open={isModalOpen}
          onModalToggle={onModalToggle}
          className="flex-1"
        />
      </React.Fragment>
    );
  }
}

ServingFoodItems.propTypes = {
  nutritionCodes: PropTypes.array.isRequired,
  itemCategories: PropTypes.array.isRequired,
  additionalItems: PropTypes.array,
  currentSelectedFoodItems: PropTypes.arrayOf(PropTypes.object),
  tabClickHandler: PropTypes.func,
  onItemClick: PropTypes.func,
};
export default ServingFoodItems;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/individualServing/component/ServingFoodItems.js